// Setup test employees for development
// This ensures consistent employee data for testing document flow

const setupTestEmployees = () => {
    // Check if employees already exist
    const existingEmployees = localStorage.getItem('hrportal_employees');
    if (existingEmployees) {
        console.log('Employees already exist, skipping setup');
        return JSON.parse(existingEmployees);
    }

    // Create test employees with consistent IDs
    const testEmployees = [
        {
            id: 'EMP001',
            employee_id: 'EMP001',
            employee_code: 'EMP001',
            first_name: 'John',
            last_name: 'Doe',
            email: 'john.doe@company.com',
            work_email: 'john.doe@company.com',
            phone: '+1234567890',
            department: 'Engineering',
            designation: 'Senior Developer',
            joining_date: '2023-01-15',
            employment_status: 'Active',
            loginCredentials: {
                loginId: 'john.doe@company.com',
                password: 'john123'
            },
            accessLevel: 'employee',
            role: 'employee'
        },
        {
            id: 'EMP002',
            employee_id: 'EMP002',
            employee_code: 'EMP002',
            first_name: 'Jane',
            last_name: 'Smith',
            email: 'jane.smith@company.com',
            work_email: 'jane.smith@company.com',
            phone: '+1234567891',
            department: 'Human Resources',
            designation: 'HR Manager',
            joining_date: '2022-06-01',
            employment_status: 'Active',
            loginCredentials: {
                loginId: 'jane.smith@company.com',
                password: 'jane123'
            },
            accessLevel: 'manager',
            role: 'manager'
        },
        {
            id: 'EMP003',
            employee_id: 'EMP003',
            employee_code: 'EMP003',
            first_name: 'Bob',
            last_name: 'Wilson',
            email: 'bob.wilson@company.com',
            work_email: 'bob.wilson@company.com',
            phone: '+1234567892',
            department: 'Sales',
            designation: 'Sales Executive',
            joining_date: '2023-03-20',
            employment_status: 'Active',
            loginCredentials: {
                loginId: 'bob.wilson@company.com',
                password: 'bob123'
            },
            accessLevel: 'employee',
            role: 'employee'
        },
        {
            id: 'ADMIN001',
            employee_id: 'ADMIN001',
            employee_code: 'ADMIN001',
            first_name: 'Admin',
            last_name: 'User',
            email: 'admin@company.com',
            work_email: 'admin@company.com',
            phone: '+1234567800',
            department: 'Administration',
            designation: 'System Administrator',
            joining_date: '2020-01-01',
            employment_status: 'Active',
            loginCredentials: {
                loginId: 'admin@company.com',
                password: 'admin123'
            },
            accessLevel: 'admin',
            role: 'admin',
            is_admin: true
        }
    ];

    // Save to localStorage
    localStorage.setItem('hrportal_employees', JSON.stringify(testEmployees));
    console.log('✅ Test employees setup completed');
    console.log('Available test accounts:');
    testEmployees.forEach(emp => {
        console.log(`  - ${emp.loginCredentials.loginId} / ${emp.loginCredentials.password} (${emp.accessLevel})`);
    });

    return testEmployees;
};

// Also create a function to ensure user login consistency
const ensureUserIdConsistency = () => {
    const currentUser = JSON.parse(localStorage.getItem('user') || '{}');

    if (currentUser && currentUser.email) {
        // Find the employee from hrportal_employees
        const employees = JSON.parse(localStorage.getItem('hrportal_employees') || '[]');
        const matchingEmployee = employees.find(emp =>
            emp.email === currentUser.email ||
            emp.loginCredentials?.loginId === currentUser.email
        );

        if (matchingEmployee) {
            // Update the user object with consistent IDs
            const updatedUser = {
                ...currentUser,
                id: matchingEmployee.id,
                employee_id: matchingEmployee.employee_id || matchingEmployee.id,
                employee_code: matchingEmployee.employee_code,
                user_id: matchingEmployee.id
            };

            localStorage.setItem('user', JSON.stringify(updatedUser));
            console.log('✅ User ID consistency ensured:', {
                email: updatedUser.email,
                id: updatedUser.id,
                employee_id: updatedUser.employee_id
            });

            return updatedUser;
        }
    }

    return currentUser;
};

// Make functions globally available
window.setupTestEmployees = setupTestEmployees;
window.ensureUserIdConsistency = ensureUserIdConsistency;

// Auto-run on load to ensure consistency
if (typeof window !== 'undefined') {
    console.log('🔧 Employee setup utility loaded');
    console.log('Run setupTestEmployees() to create test employees');
    console.log('Run ensureUserIdConsistency() to fix user ID issues');
}

export { setupTestEmployees, ensureUserIdConsistency };